/** Unity explosion contract: assembled = 1, maximum separation = 10. */
export const EXPLOSION_FACTOR_MIN = 1;
export const EXPLOSION_FACTOR_MAX = 10;

export function normalizeExplosionFactor(value: unknown): number {
  const numeric = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(numeric)) return EXPLOSION_FACTOR_MIN;
  return Math.min(
    EXPLOSION_FACTOR_MAX,
    Math.max(EXPLOSION_FACTOR_MIN, numeric),
  );
}

export function explosionPercentageToFactor(percentage: number): number {
  const clamped = Math.min(100, Math.max(0, percentage));
  return EXPLOSION_FACTOR_MIN
    + (clamped / 100) * (EXPLOSION_FACTOR_MAX - EXPLOSION_FACTOR_MIN);
}

export function explosionFactorToPercentage(factor: number): number {
  return (
    ((normalizeExplosionFactor(factor) - EXPLOSION_FACTOR_MIN)
      / (EXPLOSION_FACTOR_MAX - EXPLOSION_FACTOR_MIN))
    * 100
  );
}
